export const Filters = {
  RECOMMENDED: "RECOMMENDED",
  ORDERED: "ORDERED",
  ALL: "ALL",
};
